import { useEffect, useRef } from 'react';
import { matchPath, useLocation } from 'react-router-dom';
import {
  DEFAULT_PAGE_TITLE,
  RouteTitleConfig,
  routeTitleConfig,
} from '../../routes/routeTitleConfig';

declare global {
  interface Window {
    dataLayer?: Array<Record<string, unknown>>;
  }
}

const resolveTitleForPath = (
  pathname: string,
  config: RouteTitleConfig[],
): string => {
  for (const route of config) {
    const match = matchPath(
      {
        path: route.path,
        end: route.end ?? true,
      },
      pathname,
    );

    if (match) {
      return route.title;
    }
  }

  return DEFAULT_PAGE_TITLE;
};

export const PageMetadataHandler = () => {
  const location = useLocation();
  const lastTrackedPath = useRef<string>('');

  useEffect(() => {
    const compositePath = `${location.pathname}${location.search}${location.hash}`;

    if (lastTrackedPath.current === compositePath) {
      return;
    }

    lastTrackedPath.current = compositePath;

    const title = resolveTitleForPath(location.pathname, routeTitleConfig);

    if (document.title !== title) {
      document.title = title;
    }

    window.dataLayer?.push({
      event: 'page_view',
      page_title: title,
      page_path: `${location.pathname}${location.search}`,
      page_location: window.location.href,
    });
  }, [location.pathname, location.search, location.hash]);

  return null;
};

export default PageMetadataHandler;
